<template>
  <div style="font-size: 13px">
    <b-modal
      id="modalTaxInformation"
      size="xl"
      ok-title="Salvar"
      hide-header
      centered
      @hidden="closeModal"
    >
      <button class="closeModal" @click="closeModal">
        <b-icon-x scale="1.3"></b-icon-x>
      </button>
      <template #modal-footer>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex">
          <div class="contentBtnRef">
            <div style="display: flex; gap: 40px">
              <b-button
                style="
                  padding: 3px 30px;
                  border: none !important;
                  color: black;
                  background-color: #cbcbcb !important;
                "
                size="sm"
                @click="findAllRefs"
                v-b-modal.modal-center
                >Refs cadastradas</b-button
              >
            </div>
            <div style="display: flex; gap: 40px">
              <b-button
                v-if="infoFiscal.id"
                style="
                  padding: 5px 30px;
                  border: none !important;
                  color: black;
                  background-color: #cbcbcb !important;
                "
                size="sm"
                @click="clear"
                >Novo REF</b-button
              >
              <b-button
                style="
                  padding: 3px 40px;
                  border: none !important;
                  background-color: #00395d !important;
                "
                @click="handleSaveOrUpdate"
                size="sm"
              >
                {{ infoFiscal.id ? "Atualizar REF" : "Salvar REF" }}
              </b-button>
            </div>
          </div>
        </div>
      </template>
      <div class="contentTitle">
        <span class="titleTax">Informações Fiscais De Produto</span>

        <div style="display: flex; justify-content: end; gap: 1.3rem">
          <label class="custom-checkbox">
            <input v-model="activeCtn" name="dummy" type="checkbox" />
            <span class="checkmark"></span>
            Habilitar ISSQN
          </label>

          <label class="custom-checkbox">
            <input
              v-model="infoFiscal.flags.isManual"
              name="dummy"
              type="checkbox"
            />
            <span class="checkmark"></span>
            Imposto manual ?
          </label>
        </div>
      </div>
      <div class="heigthModal">
        <Tabs
          :tabs="tabs"
          :tabSelected="tabSelected"
          :noPadding="true"
          newStyleTabs="newStyleTabs"
        >
          <template v-slot:geral>
            <div class="scrollIssqn">
              <b-form-group
                id="input-group-1"
                label="Descrição"
                label-for="textarea"
                size="sm"
                class="styleLabel"
              >
                <b-form-textarea
                  id="textarea"
                  placeholder="Descreva a classificação desse imposto para melhor gerenciamento. Ex: Classe de impostos para Saída de produtos de fabricação própria."
                  rows="6"
                  no-resize
                  v-model="infoFiscal.descricao"
                ></b-form-textarea>
              </b-form-group>
            </div>
          </template>

          <template v-slot:ICMS>
            <div class="scrollIssqn">
              <b-form-input
                v-model="infoFiscal.id"
                text-field="text"
                type="text"
                hidden
              ></b-form-input>
              <div class="rowContent">
                <div class="selectPlus" style="width: 15%">
                  <label class="fixedSelect2">Tipo de Tributação</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.icms[0].tipo_tributacao"
                    :options="taxForSelectBoxes.icms.tipo_tributacao"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus" style="width: 20%">
                  <label class="fixedSelect2">Cenário</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.icms[0].cenario"
                    :options="taxForSelectBoxes.icms.cenario"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus" style="width: 10%">
                  <label class="fixedSelect2">Tipo Pessoa</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.icms[0].tipo_pessoa"
                    :options="taxForSelectBoxes.icms.tipo_pessoa"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus" style="width: 60%">
                  <label class="fixedSelect2">Situação tributária</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.icms[0].situacao_tributaria"
                    :options="taxForSelectBoxes.icms.situacao_tributaria"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="input-group" style="width: 10%">
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.icms[0].codigo_cfop"
                  />
                  <label class="user-label"> Código CFOP </label>
                </div>
              </div>
              <div class="rowContentChk">
                <b-form-group
                  :hidden="
                    infoFiscal.refObject.icms[0].tipo_pessoa !== 'juridica'
                  "
                >
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="infoFiscal.refObject.icms[0].nao_contribuinte"
                    name="checkbox-1"
                    style="font-size: 12px; width: 100%"
                  >
                    Marque essa opção caso a configuração deste cenário seja
                    específico para Pessoa Jurídica não contribuinte do ICMS ou
                    Consumidor final.
                  </b-form-checkbox>
                </b-form-group>
              </div>
              <div class="rowContent" style="gap: 20px; flex-wrap: wrap">
                <div
                  class="input-group"
                  style="width: 25%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_credito
                  "
                >
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.icms[0].aliquota_credito"
                  />
                  <label class="user-label">
                    Alíquota aplicável de cálculo de crédito %
                  </label>
                </div>
                <div
                  class="input-group"
                  style="width: 17%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_diferimento
                  "
                >
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.icms[0].aliquota_diferimento"
                  />
                  <label class="user-label" style="left: -15px">
                    Alíquota do diferimento ICMS %
                  </label>
                </div>
                <div
                  class="input-group"
                  style="width: 20%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_diferimento_fcp
                  "
                >
                  <input
                    required
                    class="input borderInput"
                    v-model="
                      infoFiscal.refObject.icms[0].aliquota_diferimento_fcp
                    "
                  />
                  <label class="user-label" style="left: -15px">
                    Alíquota do diferimento ICMS (FCP) %
                  </label>
                </div>
                <div
                  class="input-group"
                  style="width: 15%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_icms
                  "
                >
                  <input
                    required
                    class="input borderInput"
                    v-model="
                      infoFiscal.refObject.icms[0].aliquota_icms[0].aliquota
                    "
                  />
                  <label class="user-label"> Alíquota ICMS </label>
                </div>

                <div
                  class="selectPlus"
                  style="width: 15%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_icms
                  "
                >
                  <label class="fixedSelect2">Alíquota ICMS Estado</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="
                      infoFiscal.refObject.icms[0].aliquota_icms[0].estado
                    "
                    :options="taxForSelectBoxes.icms.estados"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>

                <div
                  class="input-group"
                  style="width: 10%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_mva
                  "
                >
                  <input
                    required
                    class="input borderInput"
                    v-model="
                      infoFiscal.refObject.icms[0].aliquota_mva[0].aliquota
                    "
                  />
                  <label class="user-label"> Alíquota MVA: % </label>
                </div>
                <div
                  class="selectPlus"
                  style="width: 15%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_mva
                  "
                >
                  <label class="fixedSelect2">Aliquota MVA Estado</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="
                      infoFiscal.refObject.icms[0].aliquota_mva[0].estado
                    "
                    :options="taxForSelectBoxes.icms.estados"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div
                  class="input-group"
                  style="width: 25%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_reducao
                  "
                >
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.icms[0].aliquota_reducao"
                  />
                  <label class="user-label" style="left: -15px">
                    Alíquota da redução da base de cálculo ICMS %
                  </label>
                </div>

                <div class="rowContent" style="gap: 10px">
                  <div
                    class="selectPlus"
                    style="width: 50%"
                    v-if="
                      objectIcms[
                        infoFiscal.refObject.icms[0].situacao_tributaria
                      ].deducao_desoneracao
                    "
                  >
                    <label class="fixedSelect2">Dedução Desoneração</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      v-model="infoFiscal.refObject.icms[0].deducao_desoneracao"
                      :options="[
                        { value: 0, text: 'Não' },
                        { value: 1, text: 'Sim' },
                      ]"
                    ></b-form-select>
                  </div>
                </div>

                <div
                  class="selectPlus"
                  style="width: 25%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .motivo_desoneracao
                  "
                >
                  <label class="fixedSelect2"
                    >Motivo da Desoneração do ICMS</label
                  >
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.icms[0].motivo_desoneracao"
                    :options="taxForSelectBoxes.icms.motivo_desoneracao"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div
                  class="input-group"
                  style="width: 25%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .aliquota_reducao_st
                  "
                >
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.icms[0].aliquota_reducao_st"
                  />
                  <label class="user-label" style="left: -15px">
                    Alíquota da redução da base de cálculo ICMS-ST %
                  </label>
                </div>
                <div
                  class="selectPlus"
                  style="width: 25%"
                  v-if="
                    infoFiscal.refObject.icms[0].situacao_tributaria &&
                    objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                      .motivo_desoneracao_st
                  "
                >
                  <label class="fixedSelect2"
                    >Motivo da Desoneração do ICMS-ST</label
                  >
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.icms[0].motivo_desoneracao_st"
                    :options="taxForSelectBoxes.icms.motivo_desoneracao_st"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
              </div>

              <b-form-group
                class="col-sm-12 col-md-12 col-lg-9 col-xl-9 mt-4"
                v-if="
                  infoFiscal.refObject.icms[0].situacao_tributaria &&
                  objectIcms[infoFiscal.refObject.icms[0].situacao_tributaria]
                    .beneficio_fiscal
                "
              >
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="enableBeneficioFiscal"
                  name="checkbox-1"
                >
                  Habilitar Benefício fiscal
                </b-form-checkbox>
              </b-form-group>
              <div class="selectPlus" v-if="enableBeneficioFiscal">
                <label class="fixedSelect2">Benefício fiscal: Estado</label>
                <b-form-select
                  class="borderInput shadow-none"
                  v-model="
                    infoFiscal.refObject.icms[0].beneficio_fiscal[0].estado
                  "
                  :options="taxForSelectBoxes.icms.beneficioFiscalEstados"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </div>
              <div class="input-group" v-if="enableBeneficioFiscal">
                <input
                  required
                  class="input borderInput"
                  v-model="
                    infoFiscal.refObject.icms[0].beneficio_fiscal[0].codigo
                  "
                />
                <label class="user-label"> Código do Benefício Fiscal </label>
              </div>
            </div>
          </template>
          <template v-slot:IPI>
            <div class="scrollIssqn">
              <b-row class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="rowContent">
                  <div class="selectPlus">
                    <label class="fixedSelect2">Tipo pessoa</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      v-model="infoFiscal.refObject.ipi[0].tipo_pessoa"
                      :options="taxForSelectBoxes.ipi.tipo_pessoa"
                      value-field="value"
                      text-field="text"
                    >
                    </b-form-select>
                  </div>

                  <div class="selectPlus">
                    <label class="fixedSelect2">Cenário</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      v-model="infoFiscal.refObject.ipi[0].cenario"
                      :options="taxForSelectBoxes.ipi.cenario"
                      value-field="value"
                      text-field="text"
                    >
                    </b-form-select>
                  </div>

                  <div class="selectPlus">
                    <label class="fixedSelect2">Situação tributária</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      v-model="infoFiscal.refObject.ipi[0].situacao_tributaria"
                      :options="taxForSelectBoxes.ipi.situacao_tributaria"
                      value-field="value"
                      text-field="text"
                    >
                    </b-form-select>
                  </div>
                </div>
                <div class="rowContent">
                  <div class="input-group">
                    <input
                      required
                      class="input borderInput"
                      v-model="infoFiscal.refObject.ipi[0].codigo_enquadramento"
                    />
                    <label class="user-label"> Código de enquadramento </label>
                  </div>
                  <div class="input-group">
                    <input
                      required
                      class="input borderInput"
                      v-model="infoFiscal.refObject.ipi[0].aliquota"
                    />
                    <label class="user-label">Alíquota %</label>
                  </div>
                  <div class="input-group">
                    <input
                      required
                      class="input borderInput"
                      v-model="infoFiscal.refObject.ipi[0].ipi_devolvido"
                    />
                    <label class="user-label">Valor de IPI Devolvido</label>
                  </div>
                </div>
                <div class="rowContent">
                  <p
                    style="
                      color: red;
                      margin-bottom: 0 !important;
                      font-size: 12px;
                    "
                  >
                    ** Caso não possua um código de enquadramento, mantenha o
                    valor padrão 999.
                  </p>
                </div>
              </b-row>
            </div>
          </template>

          <template v-slot:PIS>
            <div class="scrollIssqn">
              <div class="rowContent">
                <div class="selectPlus" style="width: 15%">
                  <label class="fixedSelect2">Tipo pessoa</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.pis[0].tipo_pessoa"
                    :options="taxForSelectBoxes.pis.tipo_pessoa"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus" style="width: 25%">
                  <label class="fixedSelect2">Cenário</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.pis[0].cenario"
                    :options="taxForSelectBoxes.pis.cenario"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus" style="width: 60%">
                  <label class="fixedSelect2">Situação tributária</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.pis[0].situacao_tributaria"
                    :options="taxForSelectBoxes.pis.situacao_tributaria"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="input-group" style="width: 15%">
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.pis[0].aliquota"
                  />
                  <label class="user-label"> Alíquota % </label>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:COFINS>
            <div class="scrollIssqn">
              <div class="rowContent">
                <div class="selectPlus" style="width: 15%">
                  <label class="fixedSelect2">Tipo pessoa</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.cofins[0].tipo_pessoa"
                    :options="taxForSelectBoxes.cofins.tipo_pessoa"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus" style="width: 25%">
                  <label class="fixedSelect2">Cenário</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.cofins[0].cenario"
                    :options="taxForSelectBoxes.cofins.cenario"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus" style="width: 60%">
                  <label class="fixedSelect2">Situação tributária</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.cofins[0].situacao_tributaria"
                    :options="taxForSelectBoxes.cofins.situacao_tributaria"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="input-group" style="width: 15%">
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.cofins[0].aliquota"
                  />
                  <label class="user-label"> Alíquota % </label>
                </div>
              </div>
            </div>
          </template>

          <template v-if="this.activeCtn" v-slot:ISSQN>
            <div class="scrollIssqn">
              <div class="rowContent">
                <div class="selectPlus">
                  <label class="fixedSelect2">Tipo pessoa</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.issqn[0].tipo_pessoa"
                    :options="taxForSelectBoxes.issqn.tipo_pessoa"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus">
                  <label class="fixedSelect2">Cenário</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.issqn[0].cenario"
                    :options="taxForSelectBoxes.issqn.cenario"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus">
                  <label class="fixedSelect2"
                    >Indicador de incentivo Fiscal</label
                  >
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.issqn[0].incentivo_fiscal"
                    :options="taxForSelectBoxes.issqn.incentivo_fiscal"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
              </div>
              <div class="rowContent">
                <div class="input-group">
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.issqn[0].codigo_cfop"
                  />
                  <label class="user-label"> Código CFOP </label>
                </div>

                <div class="input-group">
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.issqn[0].item_servico"
                  />
                  <label class="user-label"> Item da lista de serviços </label>
                </div>
                <div class="input-group">
                  <input
                    required
                    class="input borderInput"
                    v-model="infoFiscal.refObject.issqn[0].aliquota"
                  />
                  <label class="user-label"> Alíquota do ISSQN %</label>
                </div>
              </div>
              <div class="rowContent">
                <div class="selectPlus">
                  <label class="fixedSelect2"
                    >Indicador da exigibilidade do ISS</label
                  >
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.issqn[0].exigibilidade"
                    :options="taxForSelectBoxes.issqn.exigibilidade"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:IBS_CBS>
            <div class="scrollIssqn">
              <div class="rowContent" style="padding: 15px 0 !important">
                <div class="selectPlus">
                  <label class="fixedSelect2">Tipo pessoa</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.ibs_cbs[0].tipo_pessoa"
                    :options="taxForSelectBoxes.ibs_cbs.tipo_pessoa"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus">
                  <label class="fixedSelect2">Cenário</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="infoFiscal.refObject.ibs_cbs[0].cenario"
                    :options="taxForSelectBoxes.ibs_cbs.cenario"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus">
                  <label class="fixedSelect2">Situação tributária</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0].situacao_tributaria
                    "
                    :options="taxForSelectBoxes.ibs_cbs.situacao_tributaria"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
              </div>
              <div class="rowContent" style="padding: 15px 0 !important">
                <div class="selectPlus" style="width: 100% !important">
                  <label class="fixedSelect2"
                    >Classificação Tributária
                    {{
                      infoFiscal.refObject.ibs_cbs[0].classificacao_tributaria
                    }}</label
                  >
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0].classificacao_tributaria
                    "
                    :options="opcoesClassificacao"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
              </div>
              <div
                class="rowContentInit"
                v-if="
                  infoFiscal.refObject.ibs_cbs[0].situacao_tributaria === '550'
                "
              >
                <div class="selectPlus">
                  <label class="fixedSelect2"
                    >Situação Tributária (Regime Regular)
                  </label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0]
                        .situacao_tributaria_regular
                    "
                    :options="taxForSelectBoxes.ibs_cbs.situacao_tributaria"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="selectPlus" style="width: 100% !important">
                  <label class="fixedSelect2"
                    >Classificação Tributária (Regime Regular)</label
                  >
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0]
                        .classificacao_tributaria_regular
                    "
                    :options="opcoesClassificacaoRegular"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
              </div>
              <div
                class="rowContentInit"
                v-if="
                  infoFiscal.refObject.ibs_cbs[0].situacao_tributaria === '510'
                "
              >
                <div class="input-group-init">
                  <input
                    required
                    class="input borderInput"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0].ibs_estadual
                        .aliquota_diferimento
                    "
                  />
                  <label class="user-label" style="left: -10px !important">
                    IBS Estadual - Alíquota de Diferimento %
                  </label>
                </div>
                <div class="input-group-init">
                  <input
                    required
                    class="input borderInput"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0].ibs_municipal
                        .aliquota_diferimento
                    "
                  />
                  <label class="user-label" style="left: -10px !important">
                    IBS Municipal - Alíquota de Diferimento %
                  </label>
                </div>
                <div class="input-group-init">
                  <input
                    required
                    class="input borderInput"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0].cbs.aliquota_diferimento
                    "
                  />
                  <label class="user-label" style="left: -10px !important">
                    CBS - Alíquota de Diferimento %
                  </label>
                </div>
              </div>
              <div
                class="rowContentInit"
                v-if="
                  (infoFiscal.refObject.ibs_cbs[0].situacao_tributaria ===
                    '510' &&
                    infoFiscal.refObject.ibs_cbs[0].classificacao_tributaria ===
                      '510002') ||
                  (infoFiscal.refObject.ibs_cbs[0].situacao_tributaria ===
                    '550' &&
                    infoFiscal.refObject.ibs_cbs[0].classificacao_tributaria ===
                      '550001')
                "
              >
                <div class="selectPlus" style="width: 40% !important">
                  <label class="fixedSelect2"
                    >Classificação do Crédito Presumido</label
                  >
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0].credito_presumido
                        .classificacao
                    "
                    :options="taxForSelectBoxes.ibs_cbs.credito_presumido"
                    value-field="value"
                    text-field="text"
                  >
                  </b-form-select>
                </div>
                <div class="input-group-init">
                  <input
                    required
                    class="input borderInput"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0].credito_presumido
                        .aliquota_ibs
                    "
                  />
                  <label class="user-label" style="left: -10px !important">
                    IBS - Alíquota do Crédito Presumido %
                  </label>
                </div>
                <div class="input-group-init">
                  <input
                    required
                    class="input borderInput"
                    v-model="
                      infoFiscal.refObject.ibs_cbs[0].credito_presumido
                        .aliquota_cbs
                    "
                  />
                  <label class="user-label" style="left: -10px !important">
                    CBS - Alíquota do Crédito Presumido %
                  </label>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:info>
            <div class="scrollIssqn">
              <b-form-group
                id="input-group-1"
                label="Informações ao Fisco"
                label-for="textarea"
                size="sm"
                class="styleLabel"
              >
                <b-form-textarea
                  id="textarea"
                  rows="3"
                  no-resize
                  v-model="infoFiscal.refObject.informacoes_fisco"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Informações Complementares ao Consumidor"
                label-for="textarea"
                size="sm"
                class="styleLabel"
              >
                <b-form-textarea
                  id="textarea"
                  rows="3"
                  no-resize
                  v-model="infoFiscal.refObject.informacoes_complementares"
                ></b-form-textarea>
              </b-form-group>
            </div>
          </template>

          <template v-slot:imposto_manual>
            <div class="scrollIssqn" v-if="infoFiscal.flags.isManual">
              <ManualTax
                ref="manualTaxComponent"
                :flags="infoFiscal.flags"
                :imposto-manual="infoFiscal.imposto_manual"
                @update:impostoManual="infoFiscal.imposto_manual = $event"
                @updateFlags="infoFiscal.flags = $event"
              />
            </div>
          </template>
        </Tabs>
        <b-modal
          id="modal-center"
          hide-footer
          hide-header
          centered
          title="refs"
          size="lg"
        >
          <button
            class="closeModalSearch"
            @click="$bvModal.hide('modal-center')"
          >
            <b-icon-x scale="1.3"></b-icon-x>
          </button>
          <div class="ContentTable" style="width: 100%">
            <div class="headerTable">
              <div class="celTable" style="width: 20%">REF</div>
              <div class="celTable" style="width: 65%">Descrição</div>
              <div class="celTableActions" style="width: 15%">Ações</div>
            </div>
            <div
              v-for="ref in this.refsFiscais"
              :key="ref.id"
              class="rowSupplier"
            >
              <div class="celTable" style="width: 20%">
                {{ ref.ref }}
              </div>
              <div class="celTable" style="width: 65%">
                {{ ref.descricao }}
              </div>
              <div class="celTableActions" style="width: 15%">
                <span
                  v-b-tooltip.hover.top="'Excluir'"
                  class="celInfos"
                  style="color: #f27474"
                  @click.stop="deleteTax(ref)"
                  ><b-icon-trash-fill scale="1.5"
                /></span>
                <span
                  v-b-tooltip.hover.top="'Duplicar'"
                  class="celInfos"
                  @click.stop="duplicate(ref.id)"
                  ><b-icon-stickies scale="1.5"
                /></span>
                <span
                  v-b-tooltip.hover.top="'Editar'"
                  class="celInfos"
                  @click.stop="edit(ref.id)"
                  ><b-icon-pencil-square scale="1.5"
                /></span>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </b-modal>
  </div>
</template>

<script>
import mixinModalTaxInformations from "../../mixins/ModalTaxInformation/ModalTaxInformation";
import Tabs from "../UI/Tabs/Tab.vue";

// import Icms from "./Icms.vue";
export default {
  mixins: [mixinModalTaxInformations],
  components: {
    Tabs,
    // Icms
  },
};
</script>

<style scoped>
.chkIssqn {
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: flex-end;
  border: solid 2px #f7f7f7;
  border-radius: 5px;
}

.scrollIssqn {
  max-height: 300px;
  overflow-x: scroll;
  background: rgb(255, 255, 255);
  padding: 10px;
  border: 1px solid #d2d1d1;
  border-radius: 5px;
}
.rowContentChk {
  padding: 0 12px;
  display: flex;
  align-items: center;
}
.styleLabel {
  color: #303030;
  font-size: 13px;
}

.form-control {
  font-size: 12px;
}

.delBill {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.btnRef {
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.heigthModal {
  width: 100%;
  min-height: 65vh;
}

.titleTax {
  font-size: 1.1rem;
  font-weight: bold;
  width: auto;
  padding: 0 0 10px 0;
  display: flex;
  color: #4b4b4b;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.contentTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px 0px 0;
  margin-bottom: 10px;
}
.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}
.closeModalSearch {
  position: absolute;
  top: 1px;
  right: 1px;
  width: 25px;
  height: 25px;
  z-index: 1000;
  color: rgb(191 15 15);
  cursor: pointer;
  border: 1px solid rgb(249 136 136);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.closeModalSearch:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.contentBtnRef {
  display: flex;
  align-items: center;
  gap: 30px;
  width: 100%;
  font-size: 14px;
  justify-content: space-between;
}
.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 5px;
  width: 100%;
  max-width: 100%;
  height: 70vh;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  background: #00395d;
  color: whitesmoke;
  font-weight: bold;
  padding: 10px;
  font-size: 13px;
}
.rowSupplier {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid #e3ebe2;
  border-radius: 2px;
  text-align: center;
  height: 40px;
  padding: 0 10px;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableActions {
  display: flex;
  width: 5%;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.celInfos {
  background: #e2e3eb;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  height: 25px;
  width: 25px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: #00395d;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 15px;
  justify-content: flex-start;
  gap: 10px;
}

.rowContentInit {
  position: relative;
  display: flex;
  width: 100%;
  padding: 15px 0;
  justify-content: flex-start;
  gap: 10px;
}

.selectPlus {
  position: relative;
  width: 40%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  font-weight: 600;
  bottom: 23px;
  left: 10px;
  z-index: 2;
  text-transform: capitalize;
  color: #666360;
  background-color: white;
  padding: 0 3px;
}

.user-label {
  position: absolute;
  left: 0px;
  font-size: 12px;
  bottom: 4px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.input-group {
  width: 33%;
}

.input-group-init {
  width: 25%;
  position: relative;
}

.input-group-mid {
  width: 45%;
}
.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
  color: #333;
  transition: color 0.3s;
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

.custom-checkbox .checkmark {
  width: 14px;
  height: 14px;
  border: 2px solid #333;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
  transform-style: preserve-3d;
}

.custom-checkbox .checkmark::before {
  content: "\2713";
  font-size: 12px;
  color: transparent;
  transition: color 0.3s, transform 0.3s;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #00395d;
  border-color: #333;
  transform: scale(1.1) rotateZ(360deg) rotateY(360deg);
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
  color: #f0f0f0;
}

.custom-checkbox:hover {
  color: #666;
}

.custom-checkbox:hover .checkmark {
  border-color: #666;
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.custom-checkbox input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  outline: none;
}

.custom-checkbox .checkmark,
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  transition: background-color 1.3s, border-color 1.3s, color 1.3s,
    transform 0.3s;
}
.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 13px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}
</style>
